import Spinner from "components/spinner";
import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  heading: string;
}
const LoadingModal = ({ heading }: IProps) => {
  return (
    <Container>
      <Typography size="2xl" weight="semibold" mb="3.2">
        {heading}
      </Typography>
      <Spinner width="4.8rem" />
    </Container>
  );
};

export default LoadingModal;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${Colors.grey1000};
  padding: 20.6rem 18.8rem;
  border-radius: 0.8rem;
  @media only screen and (max-width: 769px) {
    padding: 1rem;
    width: 45rem;
    height: 50rem;
  }
`;
